<app-page-layout>
  <app-page-bar>
    <app-bar-back-button *ngIf="test"
                         [link]="['/tests/', test.id]"
                         [tooltip]="'Тест'"></app-bar-back-button>
    <app-bar-title>Вопросы</app-bar-title>
    <button mat-icon-button
            matTooltip="Экспорт"
            (click)="exportQuestions()">
      <mat-icon>file_download</mat-icon>
    </button>
  </app-page-bar>
  <app-page-content [narrow]="true">
    <app-questions-editor *ngIf="test && questions"
                          class="questions"
                          [readonly]="!canEdit"
                          [testId]="test.id"
                          [testType]="test.type"
                          [questions]="questions"></app-questions-editor>
  </app-page-content>
</app-page-layout>
